import { __require as t } from "./main27.js";
var r, s;
function o() {
  if (s) return r;
  s = 1;
  var i = t();
  function n(u, e, a) {
    e == "__proto__" && i ? i(u, e, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : u[e] = a;
  }
  return r = n, r;
}
export {
  o as __require
};
